// src/utils/consult/iceServers.ts
//
// The ICE servers the consult WebRTC mesh dials with. Config-driven so a TURN relay can be added
// later with NO code change: set `VITE_ICE_SERVERS` to a JSON array of RTCIceServer entries, e.g.
//
//   VITE_ICE_SERVERS='[{"urls":"stun:stun.l.google.com:19302"},
//                      {"urls":["turn:turn.example:3478"],"username":"u","credential":"c"}]'
//
// (Registered in src/config/runtimeEnv.ts. SET in all four prod clinic frontend-runtime-config
// ConfigMaps with a STUN+TURN list — the default below is the fallback, not what prod runs.)
//
// A malformed value degrades to the default STUN list rather than to no ICE at all — a consult that
// still connects on STUN beats one that fails outright because of a config typo. The raw value is
// NEVER logged: a TURN entry carries a credential.
import { ENV } from '../../config/runtimeEnv';

export const DEFAULT_ICE_SERVERS: RTCIceServer[] = [
	{ urls: 'stun:stun.l.google.com:19302' },
	{ urls: 'stun:stun1.l.google.com:19302' },
	{ urls: 'stun:stun2.l.google.com:19302' },
];

const hasUrls = (entry: any): boolean =>
	!!entry &&
	typeof entry === 'object' &&
	(typeof entry.urls === 'string' ? entry.urls.length > 0 : Array.isArray(entry.urls) && entry.urls.length > 0 && entry.urls.every((u: any) => typeof u === 'string' && u.length > 0));

export function iceServersFromEnv(raw: string | undefined = (ENV as Record<string, string | undefined>).VITE_ICE_SERVERS): RTCIceServer[] {
	if (!raw) return DEFAULT_ICE_SERVERS;
	try {
		const parsed = JSON.parse(raw);
		if (Array.isArray(parsed) && parsed.length > 0 && parsed.every(hasUrls)) {
			return parsed as RTCIceServer[];
		}
	} catch {
		// fall through to the default — the event below is the whole signal
	}
	console.warn('consult.webrtc.ice_config.invalid');
	return DEFAULT_ICE_SERVERS;
}
